var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBtc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#btc_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7931A",
  d: "M23.64 14.903c-1.604 6.429-8.115 10.341-14.544 8.738C2.669 22.038-1.244 15.527.36 9.098 1.962 2.67 8.474-1.244 14.901.36c6.429 1.603 10.341 8.115 8.738 14.544"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.29 10.29c.239-1.596-.977-2.454-2.64-3.027l.54-2.163-1.316-.328-.526 2.106a55 55 0 0 0-1.054-.248l.528-2.12-1.315-.328-.54 2.162q-.431-.097-.84-.198V6.14l-1.815-.454-.35 1.406s.976.224.956.238c.533.133.63.486.613.766l-.614 2.464q.056.014.137.044l-.14-.035-.86 3.452c-.065.162-.23.405-.604.313.014.02-.957-.239-.957-.239l-.653 1.507 1.713.427c.319.08.631.164.939.243l-.545 2.187 1.315.329.54-2.165q.538.146 1.049.272l-.538 2.155 1.317.328.545-2.184c2.245.425 3.933.254 4.644-1.777.572-1.635-.029-2.578-1.21-3.193.86-.199 1.508-.764 1.681-1.933m-3.008 4.22c-.407 1.634-3.16.75-4.052.529l.723-2.899c.892.223 3.754.664 3.329 2.37m.407-4.243c-.371 1.487-2.662.732-3.406.547l.656-2.63c.743.186 3.137.532 2.75 2.083"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "btc_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgBtc;